import * as yup from 'yup';

import { SALES_FORMAT_OPTIONS } from 'src/modules/CatalogV2/const';

import messages from './messages';
import { REACT_QUILL_EMPTY_STRING } from './ReactQuillEditor';

export const getFormFieldSchema = intl =>
  yup
    .object({
      description: yup
        .string()
        .test(
          'is-not-react-quill-empty-string',
          intl.formatMessage(messages.requiredFieldError),
          value => !!value && value !== REACT_QUILL_EMPTY_STRING,
        ),
      salesFormat: yup.string().oneOf(Object.values(SALES_FORMAT_OPTIONS)),
      minimumPurchaseAmount: yup
        .number()
        .typeError(intl.formatMessage(messages.requiredFieldError))
        .required(intl.formatMessage(messages.requiredFieldError))
        .min(1, ({ min }) =>
          intl.formatMessage(messages.minNumberFieldError, { min }),
        )
        .integer(intl.formatMessage(messages.integerFieldError)),
      increaseAmount: yup
        .number()
        .typeError(intl.formatMessage(messages.requiredFieldError))
        .required(intl.formatMessage(messages.requiredFieldError))
        .min(1, ({ min }) =>
          intl.formatMessage(messages.minNumberFieldError, { min }),
        )
        .integer(intl.formatMessage(messages.integerFieldError)),
      fullPrice: yup
        .number()
        .typeError(intl.formatMessage(messages.requiredFieldError))
        .moreThan(0, ({ more }) =>
          intl.formatMessage(messages.moreThanNumberFieldError, { more }),
        )
        .required(intl.formatMessage(messages.requiredFieldError)),
      discountPercentage: yup
        .number()
        .typeError(intl.formatMessage(messages.requiredFieldError))
        .min(0, ({ min }) =>
          intl.formatMessage(messages.minNumberFieldError, { min }),
        )
        .max(100, ({ max }) =>
          intl.formatMessage(messages.maxNumberFieldError, { max }),
        ),
      suggestedRetailPrice: yup
        .number()
        .typeError(intl.formatMessage(messages.requiredFieldError))
        .moreThan(0, ({ more }) =>
          intl.formatMessage(messages.moreThanNumberFieldError, { more }),
        )
        .required(intl.formatMessage(messages.requiredFieldError)),
      isPublished: yup.boolean(),
      isInStock: yup.boolean(),
    })
    .required();
